import { Tooltip } from '@material-ui/core';
import MaterialTable, { Column } from 'material-table';
import React from 'react';

import { ISite, IUser } from '~/src/dash/api/console-api';
import { IStore } from '~/src/dash/reducers/store';
import { decorate } from '~/src/dash/utils/decorator';
import { checkUserInfoMasked } from '~/src/dash/utils/roles';

export interface IProps {
  channels: ISite[];
  onSelectRow?: (id: string) => void;
  title?: string;
  interactive?: boolean;
  bidderFloor: number;
  isHonorChannelFloorEnabled: boolean;
  user: IUser;
}

interface IState {
  columns: Array<Column<ISite>>;
  data: ISite[];
}

function renderBidFloorRow(
  channelFloor: number,
  bidderFloor: number,
  isHonorChannelFloorEnabled: boolean,
): any {
  if (isHonorChannelFloorEnabled && bidderFloor <= channelFloor) {
    return (
      <Tooltip title='Channel Floor takes precedence'>
        <p style={{ color: 'green' }}>{channelFloor}</p>
      </Tooltip>
    );
  }
  return <p style={{ color: 'black' }}>{bidderFloor}</p>;
}

function formatSiteName(user: IUser, site: ISite): string {
  return checkUserInfoMasked(user) ? 'demo_channel_' + site.ID : site.Name;
}

export const BidFloorTable = decorate(
  {
    redux: (state: IStore) => {
      return {
        user: state.user,
        session: state.session,
      };
    },
    styles: (theme: any) => ({
      paper: {
        ...theme.mixins.gutters(),
        paddingTop: theme.spacing.unit * 2,
        paddingBottom: theme.spacing.unit * 2,
        marginBottom: theme.spacing.unit * 4,
      },
      section: {
        display: 'block',
        marginBottom: theme.spacing.unit * 4,
      },
      button: {
        margin: theme.spacing.unit,
      },
    }),
    router: true,
  },
  class extends React.Component<IProps, IState> {
    state = {
      columns: [
        { title: 'ID', field: 'ID', searchable: false },
        {
          title: 'Name',
          field: 'Name',
          render: (rowData: ISite) =>
            this.props.interactive ? (
              <Tooltip title='Open this channel'>
                <p>{formatSiteName(this.props.user, rowData)}</p>
              </Tooltip>
            ) : (
              <p>{formatSiteName(this.props.user, rowData)}</p>
            ),
        },
        {
          title: 'Bid Floor',
          field: 'BidFloor',
          render: (rowData: ISite) =>
            renderBidFloorRow(
              rowData.BidFloor,
              this.props.bidderFloor,
              this.props.isHonorChannelFloorEnabled,
            ),
        },
      ],
      data: this.props.channels,
    };

    componentDidUpdate(prevProps: Readonly<IProps>): void {
      if (prevProps.channels !== this.props.channels) {
        this.setState({
          data: this.props.channels,
        });
      }
    }

    handleRowClick = (_: undefined, rowData: ISite) => {
      if (this.props.onSelectRow) {
        this.props.onSelectRow(rowData.ID.toString());
      }
    };

    render() {
      let fieldProps = {
        style: {
          paddingLeft: '20px',
          paddingRight: '20px',
          width: '100%',
        },
        title: this.props.title || 'Targeted Channels Bid Floor',
        options: {
          pageSize: 15,
          pageSizeOptions: [5, 15, 30],
        },
        columns: this.state.columns,
        data: this.state.data,
      };

      if (this.props.interactive) {
        fieldProps = Object.assign(fieldProps, { onRowClick: this.handleRowClick });
      }

      return <MaterialTable {...fieldProps} />;
    }
  },
);
